import axios, { AxiosPromise } from 'axios'
import service from '@/utils/request'
import {
    GameData,
    HallData,
    RecordData,
    RecordDataInfo,
    RequestResponse
} from 'vue'

export const AxiosSource = { Source: axios.CancelToken.source() }

/**
 * Ping Test
 * @param line
 * @param url
 * @returns
 */
export function pingServer(line: number, url: string): AxiosPromise<string> {
    let api = ''
    // const endPointPath = ''

    if (line === -1) {
        api = `${url}`
    } else if (line === 1) {
        api = `${process.env.API_LINE1}`
    } else if (line === 2) {
        api = `${process.env.API_LINE2}`
    } else if (line === 3) {
        api = `${process.env.API_LINE3}`
    }

    const params = {
        safeUrl: 'QWE~!@wwCa99AS'
    }

    return service({
        baseURL: api,
        url: 'ctrl/dList',
        method: 'GET',
        params,
        responseType: 'arraybuffer'
    })
}

export function getImage(): AxiosPromise {
    return service({
        url: `common/public/verifycode/${new Date().getTime()}`,
        responseType: 'blob'
    })
}

export function login<T>(_params: any): AxiosPromise<RequestResponse<T>> {
    const { params, token } = _params

    return service({
        method: 'POST',
        url: 'user/login/submit',
        params,
        headers: { 'Access-Token': token }
    })
}

export function getHallData(
    params: any
): AxiosPromise<RequestResponse<HallData>> {
    return service({
        url: 'common/hall/getHallData',
        method: 'GET',
        params,
        cancelToken: AxiosSource.Source.token
    })
}

export function getTableInfo(
    params: any
): AxiosPromise<RequestResponse<GameData>> {
    return service({
        url: 'common/gameTable/getDetail',
        params,
        method: 'GET',
        cancelToken: AxiosSource.Source.token
    })
}

export function editPassword(params: any): AxiosPromise<RequestResponse<any>> {
    return service({
        url: 'user/login/editPasswordSubmit',
        method: 'POST',
        params,
        cancelToken: AxiosSource.Source.token
    })
}

export function getBetHistory(
    params: any
): AxiosPromise<RequestResponse<RecordData>> {
    return service({
        url: 'common/hall/getBetRecordSummaryList',
        method: 'GET',
        params
    })
}

export function getBetHistoryDetails(
    params: any
): AxiosPromise<RequestResponse<RecordDataInfo>> {
    return service({
        url: 'common/hall/getBetRecordList',
        method: 'GET',
        params
    })
}

export function saveBet(params: any): AxiosPromise<RequestResponse<any>> {
    return service({
        url: 'common/lottery/saveBet',
        method: 'POST',
        params
    })
}

export function logOut(params: any): AxiosPromise<RequestResponse<any>> {
    return service({
        url: 'user/login/logout',
        method: 'POST',
        params,
        cancelToken: AxiosSource.Source.token
    })
}

export function getMultiTableDetail(
    params: any
): AxiosPromise<RequestResponse<HallData>> {
    return service({
        method: 'GET',
        url: 'common/gameTable/getMutliDetail',
        params
    })
}

export function showRedPacketAds(): AxiosPromise<RequestResponse<any>> {
    return service({
        method: 'GET',
        url: 'system/redPacket/redShow'
    })
}
